export const environment = {
  production: false,
  apiUrl: 'https://dev.api.hawkim.com/api',
  moyasarPublishableKey: 'pk_test_BJRrFSDEFECnddbamTxy695cQmtX4mGnPyjbCdMf',
  samsungPayServiceId: 'your_service_id',
  applePayLabel: 'Hawkim'
};
